export default __webpack_public_path__ + "static/media/mautic-negative.b059d477.svg";